import { Box, Heading, Text, Flex, Button, Icon } from "@chakra-ui/react";
import { FaLinkedin, FaEnvelope } from "react-icons/fa";
import Reveal from "./motion";
import { HomeContent } from "../data/homeContent";

type ContactCTAProps = { contactCTA: HomeContent["contactCTA"] };

const ContactCTA = ({ contactCTA }: ContactCTAProps) => (
  <Box as="section" id="contacts" py={{ base: 20, md: 24 }} px={{ base: 5, md: 8 }}>
    <Reveal
      maxW="1000px"
      mx="auto"
      textAlign="center"
      border="1px solid"
      borderColor="chalk.400"
      borderRadius="2xl"
      bg="chalk.200"
      py={{ base: 12, md: 16 }}
      px={{ base: 6, md: 10 }}
    >
      <Heading as="h2" fontFamily="heading" fontSize={{ base: "3xl", md: "4xl" }} mb={4}>
        {contactCTA.heading}
      </Heading>
      <Text color="slate.700" fontSize={{ base: "sm", md: "md" }} maxW="500px" mx="auto" mb={8}>
        {contactCTA.body}
      </Text>
      <Flex gap={4} justify="center" wrap="wrap">
        <Button
          size="lg"
          bg="lime.500"
          color="ink.900"
          fontWeight="bold"
          leftIcon={<Icon as={FaEnvelope} />}
          as="a"
          href="mailto:info@millerproductions.hu"
          _hover={{ bg: "lime.400", transform: "translateY(-2px)" }}
          transition="all 0.2s ease"
        >
          info@millerproductions.hu
        </Button>
        <Button
          size="lg"
          variant="outline"
          borderColor="chalk.500"
          color="ink.900"
          leftIcon={<Icon as={FaLinkedin} />}
          as="a"
          href="https://www.linkedin.com/company/miller-productions"
          target="_blank"
          rel="noopener noreferrer"
          _hover={{ borderColor: "lime.600", color: "lime.700", bg: "chalk.50" }}
        >
          {contactCTA.linkedinLabel}
        </Button>
      </Flex>
    </Reveal>
  </Box>
);

export default ContactCTA;
